import { TYPES } from "../actions";

const initialState = {
  etsyInfoPacks: [],
  totalCount: 0,
  currentEtsyInfoPack: null,
  etsyInfoPack: null,
  loading: false,
  error: null
};

export const tkt1EtsyInfoPackReducer = (state = initialState, action) => {
  switch (action.type) {
    case TYPES.ACTION_GET_TKT1_ETSY_INFO_PACKS_SUCCESS:
      return { 
        ...state, 
        etsyInfoPacks: action.payload.data.data || [], 
        totalCount: action.payload.data.pagination?.total_count || 0,
        loading: false,
        error: null
      };
    case TYPES.ACTION_GET_TKT1_ETSY_INFO_PACKS_FAIL:
      return { 
        ...state, 
        etsyInfoPacks: [],
        loading: false,
        error: action.payload
      };

    case TYPES.ACTION_GET_TKT1_ETSY_INFO_PACK_BY_ID_SUCCESS:
      return { 
        ...state, 
        currentEtsyInfoPack: action.payload.data,
        loading: false,
        error: null
      };
    case TYPES.ACTION_GET_TKT1_ETSY_INFO_PACK_BY_ID_FAIL:
      return { 
        ...state, 
        currentEtsyInfoPack: null,
        loading: false,
        error: action.payload
      };

    case TYPES.ACTION_GET_TKT1_ETSY_INFO_PACK_BY_MID_SUCCESS:
      console.log('Reducer: ACTION_GET_TKT1_ETSY_INFO_PACK_BY_MID_SUCCESS', action.payload);
      return { 
        ...state, 
        etsyInfoPack: action.payload.data,
        loading: false,
        error: null
      };
    case TYPES.ACTION_GET_TKT1_ETSY_INFO_PACK_BY_MID_FAIL:
      console.log('Reducer: ACTION_GET_TKT1_ETSY_INFO_PACK_BY_MID_FAIL', action.payload);
      return { 
        ...state, 
        etsyInfoPack: null,
        loading: false,
        error: action.payload
      };

    case TYPES.ACTION_SEARCH_TKT1_ETSY_INFO_PACKS_SUCCESS:
      return { 
        ...state, 
        etsyInfoPacks: action.payload.data.data || [],
        totalCount: action.payload.data.pagination?.total_count || 0,
        loading: false,
        error: null
      };
    case TYPES.ACTION_SEARCH_TKT1_ETSY_INFO_PACKS_FAIL:
      return { 
        ...state, 
        etsyInfoPacks: [],
        loading: false,
        error: action.payload
      };

    case TYPES.ACTION_CREATE_TKT1_ETSY_INFO_PACK_SUCCESS:
      return { 
        ...state, 
        etsyInfoPacks: [action.payload.data, ...state.etsyInfoPacks],
        totalCount: state.totalCount + 1,
        loading: false,
        error: null
      };
    case TYPES.ACTION_CREATE_TKT1_ETSY_INFO_PACK_FAIL:
      return { 
        ...state, 
        loading: false,
        error: action.payload
      };

    case TYPES.ACTION_UPDATE_TKT1_ETSY_INFO_PACK_SUCCESS:
      return { 
        ...state, 
        etsyInfoPacks: state.etsyInfoPacks.map(pack => 
          pack._id === action.payload.data._id ? action.payload.data : pack
        ),
        currentEtsyInfoPack: state.currentEtsyInfoPack && state.currentEtsyInfoPack._id === action.payload.data._id 
          ? action.payload.data 
          : state.currentEtsyInfoPack,
        loading: false,
        error: null
      };
    case TYPES.ACTION_UPDATE_TKT1_ETSY_INFO_PACK_FAIL:
      return { 
        ...state, 
        loading: false,
        error: action.payload
      };

    case TYPES.ACTION_DELETE_TKT1_ETSY_INFO_PACK_SUCCESS:
      return { 
        ...state, 
        etsyInfoPacks: state.etsyInfoPacks.filter(pack => pack._id !== action.payload.id),
        totalCount: Math.max(0, state.totalCount - 1),
        currentEtsyInfoPack: state.currentEtsyInfoPack && state.currentEtsyInfoPack._id === action.payload.id 
          ? null 
          : state.currentEtsyInfoPack,
        loading: false,
        error: null
      };
    case TYPES.ACTION_DELETE_TKT1_ETSY_INFO_PACK_FAIL:
      return { 
        ...state, 
        loading: false,
        error: action.payload
      };
      
    default:
      return state;
  }
};
